import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { commissionEditAction, commissionSearchAction } from './actions/CommissionActions';
import CommissionForm from './CommissionForm';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.commissionManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.commissionSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.commissionManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="master.commission_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<CommissionForm />}
            />
        ),
    },
    {
        link: RoutingUtil.commissionSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.commission_manager.search"
                editScope="master.commission_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="CommissionReducer"
                dataPath="search"
                editAction={commissionEditAction}
                redirectUrlOnEdit={RoutingUtil.commissionManagerUrl()}
                action={commissionSearchAction}
                columns={{
                    commissionName: {
                        display: 'Commission Name',
                    },
                    FromDate: {
                        display: 'FromDate',
                        type: Date,
                    },
                    ToDate: {
                        display: 'ToDate',
                        type: Date,
                    },
                    // companyId: {
                    //     display: 'Company Name',
                    //     path: 'companyId?.companyName',
                    // },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const CommissionContainer = () => (
    <CrudLayoutContainer
        title="Commission Manager"
        tabs={tabs}
        routes={routes}
    />
);

CommissionContainer.propTypes = {
};

export default CommissionContainer;
